module.exports = __webpack_public_path__ + "static/elements-of-information-theory-57f02ac62d20f3b1c31fdf6ef81dadac.jpg";